import { render, staticRenderFns } from "./hourSettings.vue?vue&type=template&id=01d87f04&"
import script from "./hourSettings.vue?vue&type=script&lang=js&"
export * from "./hourSettings.vue?vue&type=script&lang=js&"
import style0 from "./hourSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports